import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Binky from '../../common/Binky';
import Fullview from '../../common/Fullview';
import ConfirmMessage from '../../common/ConfirmMessage';
import AlertMessage from '../../common/AlertMessage';
import MasonryLayout from '../../common/MasonryLayout';
import { nextChallengeViewModel } from './next.challenge.viewmodel';
import dummy from '../../../assets/images/dummy-upload-failed.png';
import iconMultipleImages from '../../../assets/icon/icon-multiple-images.svg';
import { SHARE_CREATION_ROUTE_BANNER } from "../../../constants/routes.constants";
import './scss/no.submission.scss';
import { useAuth } from '../../auth/Auth';
import { useHistory } from 'react-router-dom';
import { feedViewModel } from '../feed/feed.view.model';
import OptimizeSignup from '../onboarding/signup_popups/OptimizeSignup';

const SingleChallengeCreationGallery = ({
  creationList,
  deleteCreationById,
  handleBinky,
  isPartnerView,
  handleComment
}) => {

  const history = useHistory();
  const { dependent, school, partner, guardian } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const [showFullview, setShowFullview] = useState(false);
  const [fullviewData, setFullviewData] = useState({});
  const handleCloseFullview = () => setShowFullview(false);
  const handleShowFullview = () => setShowFullview(true);

  const [showDeleteConfirm, setShowDeleteConfirm] = useState('hide');
  const [deleteCreationId, setDeleteCreationId] = useState(0);
  const handleShowDeleteConfirm = () => setShowDeleteConfirm('show');
  const handleCloseDeleteConfirm = () => setShowDeleteConfirm('hide');

  const [showAlertMessage, setShowAlertMessage] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const handleCloseAlertMessage = () => setShowAlertMessage(false);
  const handleShowAlertMessage = () => setShowAlertMessage(true);
  const [commentList, setCommentList] = useState([]);
  const [imageLoaded, setImageLoaded] = useState([]);

  const getComments = (creation_id) => {
    feedViewModel.commentList({ creation_id: creation_id })
      .then((res) => {
        setCommentList([...res.data]);
      })
      .catch();
  }

  const setImageLoadedFun = (id) => {
    const temp = [...imageLoaded]
    temp[id] = true;
    setImageLoaded(temp);
  }

  const getCreations = () => {
    if (creationList == null) return null;
    if (creationList.length === 0) {
      return (
        <section className="no-submission-section">
          <div className="text">Be the first one to submit!</div>
        </section>

        // <Container className="no-creation">
        //   <Row className="justify-content-md-center ">
        //     <Col
        //       xs={16}
        //       md={12}
        //       className="justify-content-md-center text-center"
        //     >
        //       <img src={imageLetsgo} />
        //       <br />
        //       <div className="text">Be the first one to submit!</div>
        //     </Col>
        //   </Row>
        // </Container>
      );
    } else {
      const creations = creationList.map((creation) => {
        const data = {
          id: creation.id,
          user: creation.user,
          media: creation.media,
          title: creation.title,
          binky_count: creation.binky_count,
          comment_count: creation.comment_count,
          binky_id: creation.binky_id,
          description: creation.description,
          created_at: creation.created_at,
        };
        const showFullviewHandler = () => {
          if (isPartnerView) {
            const encoded = btoa(`{"id":${creation.id}, "slug":"creation"}`)
            history.push({
              pathname: SHARE_CREATION_ROUTE_BANNER,
              search: `?encrypt=${encoded}`
            })
          } else {
            if (!dependent && !school && !partner && !guardian) {
              setShowModal(true)
              localStorage.setItem('kids_login_location', window.location.href)
            } else {
              if (school?.user_type !== 'school' && !guardian) {
                setFullviewData(data);
                getComments(data.id);
                handleShowFullview();
              }
            }
          }
        };
        const showDeleteConfirmHandler = () => {
          setDeleteCreationId(creation.id);
          handleShowDeleteConfirm();
        };

        const multipleImageIcon =
          data.media.length > 1 ? (
            <div className="multiple-images-icon-wrapper">
              <img src={iconMultipleImages} className="multiple-images" />
            </div>
          ) : (
            <></>
          );

        const content =
          data.media.length > 0 ? (
            <picture className="creation-image">
              <source srcSet={creation.media[0].s480_url} />
              <img
                onClick={showFullviewHandler}
                src={creation.media[0].url}
                alt=""
                onLoad={(e) => setImageLoadedFun(creation.id)}
              />
            </picture>
          ) : (
            <img
              className="dummy-creation"
              src={dummy}
              onClick={showDeleteConfirmHandler}
            />
          );

        const binky = (
          isPartnerView ? ""
            :
            <Binky
              creationId={data.id}
              binkyCountProp={data.binky_count}
              binkyIdProp={data.binky_id}
              feedList={creationList}
              handleBinky={handleBinky}
              className="myroomBinky"
              setShowFullview={showFullviewHandler}
            />
        );

        return (
          <div key={creation.id} className="content-wrapper" style={{ display: imageLoaded[creation.id] ? "block" : "none" }}>
            {content}
            {binky}
            {multipleImageIcon}
          </div>
        );
      });

      const handleDeleteConfirm = () => {
        nextChallengeViewModel
          .deleteCreation({ id: deleteCreationId })
          .then((res) => {
            setAlertMessage('Item deleted.');
            setShowAlertMessage(true);
            setShowDeleteConfirm('hide');
            setTimeout(() => {
              setShowAlertMessage(false);
              deleteCreationById(deleteCreationId);
            }, 1600);
          })
          .catch((err) => {
            // show something for error
            console.log(err);
          });
      };

      const deleteMessage = (
        <div>
          <span>Do you want to permanently delete item?</span>
        </div>
      );

      return (
        <div>
          <div className="creation-masonry-layout">
            <Container>
              <Row className="justify-content-md-center">
                <Col className="justify-content-md-center text-center">
                  <MasonryLayout minimum="2">{creations}</MasonryLayout>
                </Col>
              </Row>
            </Container>
            {showFullview &&
              <Fullview
                show={showFullview}
                setShowFullview={setShowFullview}
                data={fullviewData}
                deleteCreationById={deleteCreationById}
                handleClose={handleCloseFullview}
                feedList={creationList}
                handleBinky={handleBinky}
                handleComment={handleComment}
                commentList={commentList}
                getComments={getComments}
                isFullView={true}
              />
            }
            <ConfirmMessage
              handleClose={handleCloseDeleteConfirm}
              handleConfirm={handleDeleteConfirm}
              show={showDeleteConfirm}
              headerTitle="Delete Creation"
              message={deleteMessage}
              small={true}
              confirmLabel="Delete"
            />
            <AlertMessage
              title={alertMessage}
              handleClose={handleCloseAlertMessage}
              show={showAlertMessage}
            />
            <OptimizeSignup showModal={showModal} setShowModal={setShowModal} />
          </div>
        </div>
      );
    }
  };

  return <div>{getCreations()}</div>;
};

export default SingleChallengeCreationGallery;
